import { env } from '@/shared/lib/env';
import type { BuildInfo } from '@/shared/types/build.types';

/**
 * Get build information from environment variables
 * These are injected during the build process by CI/CD
 */
export const buildInfo: Readonly<BuildInfo> = {
  version: env.VITE_APP_VERSION,
  buildTime: env.VITE_BUILD_TIME || new Date().toISOString(),
  commitSha: env.VITE_COMMIT_SHA || 'local',
  environment: env.MODE,
} as const;
